// export default function cloudflareLoader({ src = "/", width, quality = 75 }) {
//   const pathOnly = new URL(src).pathname;
//   const cloudflareBaseUrl = process.env.NEXT_PUBLIC_CLOUDFLARE_BASE_URL;
//   const params = [`width=${width}`, `quality=${quality || 75}`, "format=webp"];
//   return `${cloudflareBaseUrl}/${params.join(",")}${pathOnly}`;
// }

export default function cloudflareLoader({ src, width, quality = 75 }) {

  // Remove any protocol and domain if present
  const pathOnly = src.replace(/^(https?:\/\/[^\/]+)?/, "");


  const cloudflareBaseUrl = process.env.NEXT_PUBLIC_CLOUDFLARE_BASE_URL;
  const params = [`width=${width}`, `quality=${quality || 75}`, "format=auto"];
  return `${cloudflareBaseUrl}/${params.join(",")}${pathOnly}`;
}
